<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>{{ header }}</h1>
        </template>
        <p class="mb-2 text-sm text-gray-darker">{{ brief }}</p>
        <p>
            <input id="address" type="radio" name="type" value="address" class="hidden" v-model="type">
            <label for="address" class="cursor-pointer">
                <div class="flex items-start p-3">
                    <span class="indicator w-4 h-4 inline-block rounded-full border border-primary flex-shrink-0 bg-primary-lighter"></span>
                    <div class="ml-2 min-w-0">
                        <p class="leading-none">{{ ctaAddresses }}</p>
                        <p class="text-sm text-gray-darker truncate">{{ exampleFromAddresses }}</p>
                    </div>
                </div>
            </label>
        </p>

        <p>
            <input id="domain" type="radio" name="type" value="domain" class="hidden" v-model="type">
            <label for="domain" class="cursor-pointer">
                <div class="flex items-start p-3">
                    <span class="indicator w-4 h-4 inline-block rounded-full border border-primary flex-shrink-0 bg-primary-lighter"></span>
                    <div class="ml-2 min-w-0">
                        <p class="leading-none">{{ ctaDomains }}</p>
                        <p class="text-sm text-gray-darker truncate">{{ exampleFromDomains }}</p>
                    </div>
                </div>
            </label>
        </p>

        <!-- <p>
            <input id="keyword" type="radio" name="type" value="keyword" class="hidden" v-model="type">
            <label for="keyword" class="cursor-pointer">
                <div class="flex items-start p-3">
                    <span class="indicator w-4 h-4 inline-block rounded-full border border-primary flex-shrink-0 bg-primary-lighter"></span>
                    <div class="ml-2 min-w-0">
                        <p class="leading-none">{{ ctaSubjects }}</p>
                        <p class="text-sm text-gray-darker truncate">{{ exampleSubjects }}</p>
                    </div>
                </div>
            </label>
        </p> -->

        <template v-slot:footer>
            <progressable-button
                type="submit"
                class="py-2 px-4 rounded-md bg-primary text-white font-bold"
                :loading="loading"
                state="Confirming..."
                @click.native="submit"
            >
                Confirm
            </progressable-button>
            <button class="ml-2 py-2 px-4 rounded-md bg-primary-lightest" @click="close">Cancel</button>
        </template>
    </modal-component>
</template>

<script>
export default {
    props: {
        action: {
            type: String,
            required: true,
        },
        messages: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            type   : 'address',
            loading: false,
        }
    },
    computed: {
        header() {
            return this.action === 'allow' ? 'Deliver Always...' : 'Block...';
        },
        brief() {
            return this.action === 'allow'
                ? 'E-mails will be delivered to your inbox at your delivery schedule.'
                : 'E-mails will be blocked away from your inbox.';
        },
        uniqueAddresses() {
            return this.messages.map(message => message.from_address).filter(this.uniqueFilter);
        },
        uniqueDomains() {
            return this.messages.map(message => message.from_domain).filter(this.uniqueFilter);
        },
        uniqueSubjects() {
            return this.messages.map(message => message.subject).filter(this.uniqueFilter);
        },
        ctaAddresses() {
            return this.uniqueAddresses.length > 1 ? 'From these email addresses' : 'From this email address';
        },
        ctaDomains() {
            return this.uniqueDomains.length > 1 ? 'From these domains' : 'From this domain';
        },
        ctaSubjects() {
            return this.uniqueDomains.length > 1 ? 'With similar subjects' : 'With similar subject';
        },
        exampleFromAddresses() {
            return this.uniqueAddresses.join(', ')
        },
        exampleFromDomains() {
            return this.uniqueDomains.join(', ')
        },
        exampleSubjects() {
            return this.uniqueSubjects.join(', ')
        },
    },
    methods: {
        uniqueFilter(value, index, self) { 
            return self.indexOf(value) === index;
        },
        getValues() {
            switch (this.type) {
                case 'domain':
                    return this.uniqueDomains;

                case 'address':
                    return this.uniqueAddresses;
                
                case 'keyword':
                    return this.uniqueSubjects;
            
                default:
                    return '';
            }
        },
        submit() {
            this.$emit('resolve', {
                type  : this.type,
                values: this.getValues(),
                action: this.action,
            });
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>